<template>
  <div class="cir-wrap">
    <span v-for="(item, index) in cirData" :key="item.id" class="cir-normal" :class="{'cir-light':item.show}"
          @click="cirClick(index)"></span>
  </div>
</template>

<script>
  export default {
    name: "circular-sidewards",
    props: ['cirData','timerFlag'],
    created() {
    },
    methods: {
      cirClick(index) {
        let i = 0
        while (i < this.cirData.length) {
          this.cirData[i].show = false;
          i++;
        }
        this.cirData[index].show = true;
        this.$emit('update:updateCir', this.cirData);
        this.$emit('update:timerFlag', this.timerFlag);
      }
    }
  }
</script>

<style lang="less" scoped>
  .cir-wrap {
    margin-top: 60px;
    text-align: center;
    .cir-normal {
      vertical-align: middle;
      display: inline-block;
      width: 10px;
      height: 10px;
      background: #e5e5e5;
      border-radius: 50%;
      margin-right: 20px;
      cursor: pointer;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .cir-light {
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      background: white;
      border: 4px solid #0AD3FD;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/plug/CircularSidewards.vue